// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --shell-primary: var(--primary-color);
  --shell-primary-hover: color-mix(in srgb, var(--shell-primary), black 12%);
  --shell-soft: color-mix(in srgb, var(--shell-primary) 9%, white);
  --shell-background: color-mix(in srgb, var(--shell-primary) 3%, white);
  --shell-border: color-mix(in srgb, var(--shell-primary) 13%, white);
  --shell-muted: #73849b;
  --shell-text: #172b46;
}

.layout-container {
  display: flex;
  height: 100vh;
  height: 100dvh;
  width: 100%;
  overflow: hidden;
  background: var(--shell-background);
  color: var(--shell-text);
}
.layout-container__sidebar {
  width: 284px;
  flex: 0 0 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: white;
  border-inline-end: 1px solid var(--shell-border);
  overflow: hidden;
  transition: width 260ms cubic-bezier(0.4, 0, 0.2, 1);
}
.layout-container__sidebar--header {
  height: 56px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 16px;
  border-bottom: 1px solid var(--shell-border);
  text-decoration: none;
  color: inherit;
}
.layout-container__sidebar--content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 12px;
  scrollbar-width: thin;
}
.layout-container__sidebar--footer {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  padding: 16px;
  border-top: 1px solid var(--shell-border);
}
.layout-container__main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.layout-container__main--header {
  min-height: 56px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 8px 26px;
  border-bottom: 1px solid var(--shell-border);
  background: white;
  z-index: 10;
}
.layout-container__main--content {
  flex: 1;
  min-height: 0;
  display: flex;
  padding: 28px 26px;
}

.brand-logo {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  display: grid;
  place-items: center;
}
.brand-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.brand-details {
  min-width: 0;
}
.brand-details h2 {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
}
.brand-details p {
  margin: 2px 0 0;
  font-size: 10px;
  color: var(--shell-muted);
}

.sidebar-copy {
  opacity: 1;
  white-space: nowrap;
  transition: opacity 160ms ease, visibility 0ms;
}

.nav-group {
  margin-bottom: 24px;
}
.nav-group:last-child {
  margin-bottom: 0;
}

.group-title {
  height: 22px;
  padding-inline: 12px;
  font-size: 11px;
  color: var(--shell-muted);
  font-weight: 500;
  transition: height 260ms ease, opacity 160ms ease;
}

.nav-item {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 30px;
  gap: 12px;
  padding: 6px 12px;
  margin-bottom: 5px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--shell-text);
  font: inherit;
  font-size: 13px;
  text-align: start;
  text-decoration: none;
  transition: background 160ms ease, color 160ms ease;
}
.nav-item .material-symbols-outlined {
  font-size: 20px;
  width: 20px;
  flex-shrink: 0;
  color: var(--shell-primary);
}
.nav-item:hover {
  background: var(--shell-background);
  color: var(--shell-primary);
}
.nav-item.active {
  background: var(--shell-soft);
  color: var(--shell-primary);
  font-weight: 600;
}
.nav-item.unavailable {
  color: var(--shell-muted);
  cursor: not-allowed;
  opacity: 0.65;
  background: transparent;
}

.nav-tooltip-target {
  display: block;
  cursor: not-allowed;
}
.nav-tooltip-target .unavailable {
  pointer-events: none;
}

.user-profile {
  flex: 1;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 12px;
  color: inherit;
  text-decoration: none;
  min-width: 0;
}

.avatar {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 10px;
  background: var(--shell-soft);
  color: var(--shell-primary);
  font-size: 13px;
  font-weight: 600;
  overflow: hidden;
}
.avatar img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: white;
}

.user-info {
  min-width: 0;
}

.user-name,
.user-company {
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-name {
  font-size: 13px;
  font-weight: 500;
}

.user-company {
  font-size: 11px;
  color: var(--shell-muted);
  margin-top: 3px;
}

.toggle-button,
.dropdown-trigger,
.logout-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--shell-text);
  cursor: pointer;
  font: inherit;
  transition: color 160ms ease, background 160ms ease;
}
.toggle-button:hover, .toggle-button.open,
.dropdown-trigger:hover,
.dropdown-trigger.open,
.logout-button:hover,
.logout-button.open {
  color: var(--shell-primary);
  background: var(--shell-soft);
}

.toggle-button {
  width: 38px;
  height: 38px;
  flex-shrink: 0;
}
.toggle-button svg {
  width: 23px;
  height: 23px;
}

.logout-button {
  width: 32px;
  height: 36px;
  flex-shrink: 0;
}
.logout-button span {
  font-size: 20px;
}

.header-separator {
  width: 1px;
  height: 22px;
  flex-shrink: 0;
  background: var(--shell-border);
}

.mobile-sidebar-close {
  display: none;
}

.header-right-slot {
  display: flex;
  align-items: center;
  gap: 22px;
  min-width: 0;
}

.dropdown-wrapper {
  position: relative;
  flex-shrink: 0;
}

.dropdown-trigger {
  gap: 6px;
  min-height: 32px;
  padding: 4px 8px;
  border: 0;
  border-radius: 999px;
  font-size: 13px;
}
.dropdown-trigger .material-symbols-outlined {
  font-size: 19px;
}

.dropdown-chevron {
  transition: transform 160ms ease;
}

.open .dropdown-chevron {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  inset-inline-end: 0;
  top: calc(100% + 8px);
  width: 208px;
  padding: 6px;
  background: white;
  border: 1px solid var(--shell-border);
  border-radius: 12px;
  box-shadow: 0 8px 28px rgba(23, 43, 70, 0.12);
  animation: dropdown-in 140ms ease-out;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 6px;
  padding: 10px;
  font-size: 13px;
  color: var(--shell-text);
  text-decoration: none;
}
.dropdown-item img {
  width: 18px;
  height: 18px;
  object-fit: contain;
}
.dropdown-item span {
  font-size: 16px;
  margin-inline-start: auto;
  color: var(--shell-muted);
}
.dropdown-item .social-icon {
  margin-inline-start: 0;
  width: 18px;
  font-size: 18px;
}
.dropdown-item:hover {
  background: var(--shell-soft);
  color: var(--shell-primary);
}

.dropdown-empty {
  padding: 10px;
  margin: 0;
  font-size: 12px;
  color: var(--shell-muted);
}

.quick-links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 18px;
}
.quick-links a {
  font-size: 12px;
  color: var(--shell-muted);
  text-decoration: none;
  white-space: nowrap;
}
.quick-links a:hover,
.quick-links a.active {
  color: var(--shell-primary);
}

.main-card {
  position: relative;
  flex: 1;
  min-width: 0;
  border: 1px solid var(--shell-border);
  border-radius: 18px;
  background: white;
  overflow: hidden;
}
.main-card ion-router-outlet {
  position: absolute;
  inset: 0;
}

.sidebar-collapsed .layout-container__sidebar {
  width: 72px;
}
.sidebar-collapsed .sidebar-copy {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 160ms ease, visibility 0ms 160ms;
}
.sidebar-collapsed .group-title {
  height: 0;
}
.sidebar-collapsed .nav-item {
  gap: 0;
  justify-content: center;
  padding-inline: 0;
}
.sidebar-collapsed .nav-label {
  width: 0;
  min-width: 0;
  overflow: hidden;
}
.sidebar-collapsed .layout-container__sidebar--footer {
  flex-direction: column;
  gap: 12px;
}
.sidebar-collapsed .user-profile {
  flex: none;
  width: 40px;
}
.sidebar-collapsed .user-info {
  display: none;
}

.without-shell .layout-container__main--content {
  padding: 0;
}
.without-shell .main-card {
  border: 0;
  border-radius: 0;
}

.layout-container :where(a, button):focus {
  outline: none;
}

.layout-container :where(a, button):focus-visible {
  background-color: var(--shell-soft);
  color: var(--shell-primary);
}

[dir=rtl] .toggle-button svg {
  transform: scaleX(-1);
}

@keyframes dropdown-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 1000px) {
  .layout-container__main--header {
    padding-inline: 16px;
  }
  .header-right-slot {
    gap: 12px;
  }
  .quick-links {
    gap: 8px 12px;
  }
}
@media (max-width: 760px) {
  .layout-container:not(.sidebar-collapsed) .mobile-sidebar-close {
    position: absolute;
    display: grid;
    place-items: center;
    inset-inline-end: 8px;
    top: 8px;
    width: 28px;
    height: 28px;
    border: 0;
    border-radius: 6px;
    color: var(--shell-primary);
    background: var(--shell-soft);
    cursor: pointer;
  }
  .layout-container:not(.sidebar-collapsed) .mobile-sidebar-close span {
    font-size: 18px;
  }
  .layout-container:not(.sidebar-collapsed) .brand-details {
    padding-inline-end: 24px;
  }
  .layout-container__sidebar {
    position: absolute;
    inset-block: 0;
    inset-inline-start: 0;
    width: 240px;
    z-index: 20;
    box-shadow: 8px 0 24px rgba(23, 43, 70, 0.08);
  }
  .layout-container:not(.without-shell) .layout-container__main {
    margin-inline-start: 72px;
  }
  .layout-container__main--header {
    align-items: flex-start;
    gap: 8px;
    padding: 8px 12px;
  }
  .header-right-slot {
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
  }
  .header-separator {
    display: none;
  }
  .quick-links {
    justify-content: flex-end;
    gap: 8px 10px;
  }
  .layout-container__main--content {
    padding: 12px;
  }
}
@media (max-width: 580px) {
  .layout-container__sidebar {
    width: 210px;
  }
  .layout-container:not(.sidebar-collapsed) .quick-links {
    flex-direction: column;
    align-items: flex-end;
  }
  .nav-item {
    font-size: 12px;
  }
  .nav-label {
    white-space: normal;
  }
}
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    transition: none !important;
    animation: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACI,qCAAA;EACA,0EAAA;EACA,gEAAA;EACA,sEAAA;EACA,mEAAA;EACA,sBAAA;EACA,qBAAA;AACJ;;AAEA;EACI,aAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,mCAAA;EACA,wBAAA;AACJ;AACI;EACI,YAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,gDAAA;EACA,gBAAA;EACA,oDAAA;AACR;AACQ;EACI,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,4CAAA;EACA,qBAAA;EACA,cAAA;AACZ;AAEQ;EACI,OAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;AAAZ;AAGQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,aAAA;EACA,yCAAA;AADZ;AAKI;EACI,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAHR;AAKQ;EACI,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;EACA,4CAAA;EACA,iBAAA;EACA,WAAA;AAHZ;AAMQ;EACI,OAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;AAJZ;;AASA;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AANJ;AAQI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AANR;;AAUA;EACI,YAAA;AAPJ;AASI;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AAPR;AAUI;EACI,eAAA;EACA,eAAA;EACA,yBAAA;AARR;;AAYA;EACI,UAAA;EACA,mBAAA;EACA,8CAAA;AATJ;;AAYA;EACI,mBAAA;AATJ;AAWI;EACI,gBAAA;AATR;;AAaA;EACI,YAAA;EACA,oBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,iDAAA;AAVJ;;AAaA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,mDAAA;AAVJ;AAYI;EACI,eAAA;EACA,WAAA;EACA,cAAA;EACA,2BAAA;AAVR;AAaI;EACI,mCAAA;EACA,2BAAA;AAXR;AAcI;EACI,6BAAA;EACA,2BAAA;EACA,gBAAA;AAZR;AAeI;EACI,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;AAbR;;AAiBA;EACI,cAAA;EACA,mBAAA;AAdJ;AAgBI;EACI,oBAAA;AAdR;;AAkBA;EACI,OAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,qBAAA;EACA,YAAA;AAfJ;;AAkBA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,6BAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAfJ;AAiBI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AAfR;;AAmBA;EACI,YAAA;AAhBJ;;AAmBA;;EAEI,gBAAA;EACA,uBAAA;AAhBJ;;AAmBA;EACI,eAAA;EACA,gBAAA;AAhBJ;;AAmBA;EACI,eAAA;EACA,yBAAA;EACA,eAAA;AAhBJ;;AAmBA;;;EAGI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,eAAA;EACA,aAAA;EACA,mDAAA;AAhBJ;AAkBI;;;;;EAEI,2BAAA;EACA,6BAAA;AAbR;;AAiBA;EACI,WAAA;EACA,YAAA;EACA,cAAA;AAdJ;AAgBI;EACI,WAAA;EACA,YAAA;AAdR;;AAkBA;EACI,WAAA;EACA,YAAA;EACA,cAAA;AAfJ;AAiBI;EACI,eAAA;AAfR;;AAmBA;EACI,UAAA;EACA,YAAA;EACA,cAAA;EACA,+BAAA;AAhBJ;;AAmBA;EACI,aAAA;AAhBJ;;AAmBA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAhBJ;;AAmBA;EACI,kBAAA;EACA,cAAA;AAhBJ;;AAmBA;EACI,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;AAhBJ;AAkBI;EACI,eAAA;AAhBR;;AAoBA;EACI,gCAAA;AAjBJ;;AAoBA;EACI,yBAAA;AAjBJ;;AAoBA;EACI,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,qCAAA;EACA,mBAAA;EACA,6CAAA;EACA,qCAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,wBAAA;EACA,qBAAA;AAjBJ;AAmBI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAjBR;AAoBI;EACI,eAAA;EACA,yBAAA;EACA,yBAAA;AAlBR;AAqBI;EACI,sBAAA;EACA,WAAA;EACA,eAAA;AAnBR;AAsBI;EACI,6BAAA;EACA,2BAAA;AApBR;;AAwBA;EACI,aAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;AArBJ;;AAwBA;EACI,aAAA;EACA,eAAA;EACA,aAAA;AArBJ;AAuBI;EACI,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;AArBR;AAwBI;;EAEI,2BAAA;AAtBR;;AA0BA;EACI,kBAAA;EACA,OAAA;EACA,YAAA;EACA,qCAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAvBJ;AAyBI;EACI,kBAAA;EACA,QAAA;AAvBR;;AA4BI;EACI,WAAA;AAzBR;AA4BI;EACI,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,oDAAA;AA1BR;AA6BI;EACI,SAAA;AA3BR;AA8BI;EACI,MAAA;EACA,uBAAA;EACA,iBAAA;AA5BR;AA+BI;EACI,QAAA;EACA,YAAA;EACA,gBAAA;AA7BR;AAgCI;EACI,sBAAA;EACA,SAAA;AA9BR;AAiCI;EACI,UAAA;EACA,WAAA;AA/BR;AAkCI;EACI,aAAA;AAhCR;;AAqCI;EACI,UAAA;AAlCR;AAqCI;EACI,SAAA;EACA,gBAAA;AAnCR;;AAuCA;EACI,aAAA;AApCJ;;AAuCA;EACI,mCAAA;EACA,2BAAA;AApCJ;;AAuCA;EACI,qBAAA;AApCJ;;AAuCA;EACI;IACI,UAAA;IACA,2BAAA;EApCN;EAuCE;IACI,UAAA;IACA,wBAAA;EArCN;AACF;AAwCA;EACI;IACI,oBAAA;EAtCN;EAyCE;IACI,SAAA;EAvCN;EA0CE;IACI,aAAA;EAxCN;AACF;AA2CA;EACI;IACI,kBAAA;IACA,aAAA;IACA,mBAAA;IACA,qBAAA;IACA,QAAA;IACA,WAAA;IACA,YAAA;IACA,SAAA;IACA,kBAAA;IACA,2BAAA;IACA,6BAAA;IACA,eAAA;EAzCN;EA2CM;IACI,eAAA;EAzCV;EA6CE;IACI,wBAAA;EA3CN;EA8CE;IACI,kBAAA;IACA,cAAA;IACA,qBAAA;IACA,YAAA;IACA,WAAA;IACA,6CAAA;EA5CN;EA+CE;IACI,yBAAA;EA7CN;EAgDE;IACI,uBAAA;IACA,QAAA;IACA,iBAAA;EA9CN;EAiDE;IACI,sBAAA;IACA,qBAAA;IACA,QAAA;EA/CN;EAkDE;IACI,aAAA;EAhDN;EAmDE;IACI,yBAAA;IACA,aAAA;EAjDN;EAoDE;IACI,aAAA;EAlDN;AACF;AAqDA;EACI;IACI,YAAA;EAnDN;EAsDE;IACI,sBAAA;IACA,qBAAA;EApDN;EAuDE;IACI,eAAA;EArDN;EAwDE;IACI,mBAAA;EAtDN;AACF;AAyDA;EAEI;;;IAGI,2BAAA;IACA,0BAAA;EAxDN;AACF","sourcesContent":[":host {\n    --shell-primary: var(--primary-color);\n    --shell-primary-hover: color-mix(in srgb, var(--shell-primary), black 12%);\n    --shell-soft: color-mix(in srgb, var(--shell-primary) 9%, white);\n    --shell-background: color-mix(in srgb, var(--shell-primary) 3%, white);\n    --shell-border: color-mix(in srgb, var(--shell-primary) 13%, white);\n    --shell-muted: #73849b;\n    --shell-text: #172b46;\n}\n\n.layout-container {\n    display: flex;\n    height: 100vh;\n    height: 100dvh;\n    width: 100%;\n    overflow: hidden;\n    background: var(--shell-background);\n    color: var(--shell-text);\n\n    &__sidebar {\n        width: 284px;\n        flex: 0 0 auto;\n        min-width: 0;\n        display: flex;\n        flex-direction: column;\n        background: white;\n        border-inline-end: 1px solid var(--shell-border);\n        overflow: hidden;\n        transition: width 260ms cubic-bezier(.4, 0, .2, 1);\n\n        &--header {\n            height: 56px;\n            flex-shrink: 0;\n            display: flex;\n            align-items: center;\n            gap: 12px;\n            padding: 0 16px;\n            border-bottom: 1px solid var(--shell-border);\n            text-decoration: none;\n            color: inherit;\n        }\n\n        &--content {\n            flex: 1;\n            min-height: 0;\n            overflow-y: auto;\n            overflow-x: hidden;\n            padding: 20px 12px;\n            scrollbar-width: thin;\n        }\n\n        &--footer {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            flex-shrink: 0;\n            padding: 16px;\n            border-top: 1px solid var(--shell-border);\n        }\n    }\n\n    &__main {\n        flex: 1;\n        min-width: 0;\n        display: flex;\n        flex-direction: column;\n\n        &--header {\n            min-height: 56px;\n            flex-shrink: 0;\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            gap: 16px;\n            padding: 8px 26px;\n            border-bottom: 1px solid var(--shell-border);\n            background: white;\n            z-index: 10;\n        }\n\n        &--content {\n            flex: 1;\n            min-height: 0;\n            display: flex;\n            padding: 28px 26px;\n        }\n    }\n}\n\n.brand-logo {\n    width: 30px;\n    height: 30px;\n    flex-shrink: 0;\n    display: grid;\n    place-items: center;\n\n    img {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n    }\n}\n\n.brand-details {\n    min-width: 0;\n\n    h2 {\n        margin: 0;\n        font-size: 12px;\n        font-weight: 600;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    p {\n        margin: 2px 0 0;\n        font-size: 10px;\n        color: var(--shell-muted);\n    }\n}\n\n.sidebar-copy {\n    opacity: 1;\n    white-space: nowrap;\n    transition: opacity 160ms ease, visibility 0ms;\n}\n\n.nav-group {\n    margin-bottom: 24px;\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n}\n\n.group-title {\n    height: 22px;\n    padding-inline: 12px;\n    font-size: 11px;\n    color: var(--shell-muted);\n    font-weight: 500;\n    transition: height 260ms ease, opacity 160ms ease;\n}\n\n.nav-item {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    min-height: 30px;\n    gap: 12px;\n    padding: 6px 12px;\n    margin-bottom: 5px;\n    border: 0;\n    border-radius: 8px;\n    background: transparent;\n    color: var(--shell-text);\n    font: inherit;\n    font-size: 13px;\n    text-align: start;\n    text-decoration: none;\n    transition: background 160ms ease, color 160ms ease;\n\n    .material-symbols-outlined {\n        font-size: 20px;\n        width: 20px;\n        flex-shrink: 0;\n        color: var(--shell-primary);\n    }\n\n    &:hover {\n        background: var(--shell-background);\n        color: var(--shell-primary);\n    }\n\n    &.active {\n        background: var(--shell-soft);\n        color: var(--shell-primary);\n        font-weight: 600;\n    }\n\n    &.unavailable {\n        color: var(--shell-muted);\n        cursor: not-allowed;\n        opacity: .65;\n        background: transparent;\n    }\n}\n\n.nav-tooltip-target {\n    display: block;\n    cursor: not-allowed;\n\n    .unavailable {\n        pointer-events: none;\n    }\n}\n\n.user-profile {\n    flex: 1;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    color: inherit;\n    text-decoration: none;\n    min-width: 0;\n}\n\n.avatar {\n    display: grid;\n    place-items: center;\n    width: 40px;\n    height: 40px;\n    flex-shrink: 0;\n    border-radius: 10px;\n    background: var(--shell-soft);\n    color: var(--shell-primary);\n    font-size: 13px;\n    font-weight: 600;\n    overflow: hidden;\n\n    img {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n        background: white;\n    }\n}\n\n.user-info {\n    min-width: 0;\n}\n\n.user-name,\n.user-company {\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.user-name {\n    font-size: 13px;\n    font-weight: 500;\n}\n\n.user-company {\n    font-size: 11px;\n    color: var(--shell-muted);\n    margin-top: 3px;\n}\n\n.toggle-button,\n.dropdown-trigger,\n.logout-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border: 0;\n    border-radius: 8px;\n    background: transparent;\n    color: var(--shell-text);\n    cursor: pointer;\n    font: inherit;\n    transition: color 160ms ease, background 160ms ease;\n\n    &:hover,\n    &.open {\n        color: var(--shell-primary);\n        background: var(--shell-soft);\n    }\n}\n\n.toggle-button {\n    width: 38px;\n    height: 38px;\n    flex-shrink: 0;\n\n    svg {\n        width: 23px;\n        height: 23px;\n    }\n}\n\n.logout-button {\n    width: 32px;\n    height: 36px;\n    flex-shrink: 0;\n\n    span {\n        font-size: 20px;\n    }\n}\n\n.header-separator {\n    width: 1px;\n    height: 22px;\n    flex-shrink: 0;\n    background: var(--shell-border);\n}\n\n.mobile-sidebar-close {\n    display: none;\n}\n\n.header-right-slot {\n    display: flex;\n    align-items: center;\n    gap: 22px;\n    min-width: 0;\n}\n\n.dropdown-wrapper {\n    position: relative;\n    flex-shrink: 0;\n}\n\n.dropdown-trigger {\n    gap: 6px;\n    min-height: 32px;\n    padding: 4px 8px;\n    border: 0;\n    border-radius: 999px;\n    font-size: 13px;\n\n    .material-symbols-outlined {\n        font-size: 19px;\n    }\n}\n\n.dropdown-chevron {\n    transition: transform 160ms ease;\n}\n\n.open .dropdown-chevron {\n    transform: rotate(180deg);\n}\n\n.dropdown-menu {\n    position: absolute;\n    inset-inline-end: 0;\n    top: calc(100% + 8px);\n    width: 208px;\n    padding: 6px;\n    background: white;\n    border: 1px solid var(--shell-border);\n    border-radius: 12px;\n    box-shadow: 0 8px 28px rgba(23, 43, 70, .12);\n    animation: dropdown-in 140ms ease-out;\n}\n\n.dropdown-item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    border-radius: 6px;\n    padding: 10px;\n    font-size: 13px;\n    color: var(--shell-text);\n    text-decoration: none;\n\n    img {\n        width: 18px;\n        height: 18px;\n        object-fit: contain;\n    }\n\n    span {\n        font-size: 16px;\n        margin-inline-start: auto;\n        color: var(--shell-muted);\n    }\n\n    .social-icon {\n        margin-inline-start: 0;\n        width: 18px;\n        font-size: 18px;\n    }\n\n    &:hover {\n        background: var(--shell-soft);\n        color: var(--shell-primary);\n    }\n}\n\n.dropdown-empty {\n    padding: 10px;\n    margin: 0;\n    font-size: 12px;\n    color: var(--shell-muted);\n}\n\n.quick-links {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px 18px;\n\n    a {\n        font-size: 12px;\n        color: var(--shell-muted);\n        text-decoration: none;\n        white-space: nowrap;\n    }\n\n    a:hover,\n    a.active {\n        color: var(--shell-primary);\n    }\n}\n\n.main-card {\n    position: relative;\n    flex: 1;\n    min-width: 0;\n    border: 1px solid var(--shell-border);\n    border-radius: 18px;\n    background: white;\n    overflow: hidden;\n\n    ion-router-outlet {\n        position: absolute;\n        inset: 0;\n    }\n}\n\n.sidebar-collapsed {\n    .layout-container__sidebar {\n        width: 72px;\n    }\n\n    .sidebar-copy {\n        opacity: 0;\n        visibility: hidden;\n        pointer-events: none;\n        transition: opacity 160ms ease, visibility 0ms 160ms;\n    }\n\n    .group-title {\n        height: 0;\n    }\n\n    .nav-item {\n        gap: 0;\n        justify-content: center;\n        padding-inline: 0;\n    }\n\n    .nav-label {\n        width: 0;\n        min-width: 0;\n        overflow: hidden;\n    }\n\n    .layout-container__sidebar--footer {\n        flex-direction: column;\n        gap: 12px;\n    }\n\n    .user-profile {\n        flex: none;\n        width: 40px;\n    }\n\n    .user-info {\n        display: none;\n    }\n}\n\n.without-shell {\n    .layout-container__main--content {\n        padding: 0;\n    }\n\n    .main-card {\n        border: 0;\n        border-radius: 0;\n    }\n}\n\n.layout-container :where(a, button):focus {\n    outline: none;\n}\n\n.layout-container :where(a, button):focus-visible {\n    background-color: var(--shell-soft);\n    color: var(--shell-primary);\n}\n\n[dir='rtl'] .toggle-button svg {\n    transform: scaleX(-1);\n}\n\n@keyframes dropdown-in {\n    from {\n        opacity: 0;\n        transform: translateY(-4px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@media (max-width: 1000px) {\n    .layout-container__main--header {\n        padding-inline: 16px;\n    }\n\n    .header-right-slot {\n        gap: 12px;\n    }\n\n    .quick-links {\n        gap: 8px 12px;\n    }\n}\n\n@media (max-width: 760px) {\n    .layout-container:not(.sidebar-collapsed) .mobile-sidebar-close {\n        position: absolute;\n        display: grid;\n        place-items: center;\n        inset-inline-end: 8px;\n        top: 8px;\n        width: 28px;\n        height: 28px;\n        border: 0;\n        border-radius: 6px;\n        color: var(--shell-primary);\n        background: var(--shell-soft);\n        cursor: pointer;\n\n        span {\n            font-size: 18px;\n        }\n    }\n\n    .layout-container:not(.sidebar-collapsed) .brand-details {\n        padding-inline-end: 24px;\n    }\n\n    .layout-container__sidebar {\n        position: absolute;\n        inset-block: 0;\n        inset-inline-start: 0;\n        width: 240px;\n        z-index: 20;\n        box-shadow: 8px 0 24px rgba(23, 43, 70, .08);\n    }\n\n    .layout-container:not(.without-shell) .layout-container__main {\n        margin-inline-start: 72px;\n    }\n\n    .layout-container__main--header {\n        align-items: flex-start;\n        gap: 8px;\n        padding: 8px 12px;\n    }\n\n    .header-right-slot {\n        flex-direction: column;\n        align-items: flex-end;\n        gap: 8px;\n    }\n\n    .header-separator {\n        display: none;\n    }\n\n    .quick-links {\n        justify-content: flex-end;\n        gap: 8px 10px;\n    }\n\n    .layout-container__main--content {\n        padding: 12px;\n    }\n}\n\n@media (max-width: 580px) {\n    .layout-container__sidebar {\n        width: 210px;\n    }\n\n    .layout-container:not(.sidebar-collapsed) .quick-links {\n        flex-direction: column;\n        align-items: flex-end;\n    }\n\n    .nav-item {\n        font-size: 12px;\n    }\n\n    .nav-label {\n        white-space: normal;\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n    *,\n    *::before,\n    *::after {\n        transition: none !important;\n        animation: none !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
